import { AlertUrls } from '../ridango.models';

export class AlertUtil {
    static processAlertUrl(url: string): AlertUrls {
        if (!url) {
            return { src: '', alt: '', type: 'url' };
        }

        if (url.includes(';')) {
            const [part1, part2] = url.split(';');
            const isFirstPartUrl = part1.startsWith('http');

            return {
                src: isFirstPartUrl ? part1 : part2 || '',
                alt: isFirstPartUrl ? part2 || '' : part1,
                type: /\.(jpg|jpeg|png|gif)$/i.test(isFirstPartUrl ? part1 : part2) ? 'image' : 'url'
            };
        }

        return {
            src: url,
            alt: '',
            type: /\.(jpg|jpeg|png|gif)$/i.test(url) ? 'image' : 'url'
        };
    }
}
